import { Field } from "../FormField";

export const PersonalTab = ({ emp, set }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <Field label="Name as per Aadhar" value={emp.name} onChange={set("name")} testId="detail-name" />
    <Field label="Phone" value={emp.phone} onChange={set("phone")} testId="detail-phone" />
    <Field label="Date of birth" value={emp.date_of_birth} onChange={set("date_of_birth")} type="date" testId="detail-dob" />
    <Field label="Gender" value={emp.gender} onChange={set("gender")} testId="detail-gender" />
    <div className="sm:col-span-2"><Field label="Address" value={emp.address} onChange={set("address")} testId="detail-address" /></div>
    <Field label="Emergency contact name" value={emp.emergency_contact_name} onChange={set("emergency_contact_name")} testId="detail-ec-name" />
    <Field label="Emergency contact phone" value={emp.emergency_contact_phone} onChange={set("emergency_contact_phone")} testId="detail-ec-phone" />
  </div>
);
